import React, { useEffect, useState } from "react";
import SubHeader from '../../components/SubHeader';
import { useNavigate } from "react-router-dom";
import { axios } from "@/lib/axios";
import { useLoadingStore } from "@/stores/loading";
import { useUserStore } from "@/stores/user";
import { useMessageModalStore } from "@/stores/message";
import * as Config from "@/config";
import { MESSAGE_NO_E01 } from "@/config";
import { LoginInformation, getLoginInformation } from "@/api/information";

export default function Top() {
  const navigate = useNavigate();
  const setLoading = useLoadingStore((state) => state.setLoading);

  const [information, setInformation] = useState<LoginInformation>();
  useEffect(() => {
	setLoading(true);
	getLoginInformation()
	  .then((res) => {
		setInformation(res.data);
	  })
	  .finally(() => {
		setLoading(false);
	  });
  }, []);

  const infoLoading = information === undefined;
  const infoExists =
	information?.information_list && information?.information_list.length > 0;

  const breadCrumbs = [
    {title: 'お知らせ'},
  ];

  return (
	<div>
		<div className="sub-header">
			<SubHeader breadCrumbs={breadCrumbs}/>
		</div>
		
		<div id="login">
			<div className="login-container">
				<div className="login-item login-item-information">
				<div className="login-item-header">
					<p>お知らせ</p>
				</div>
				<div className="login-item-body login-item-body-information">
					{infoExists
					? information?.information_list?.map((information) => (
						<section key={information.id}>
							<p className="section-header">
							<strong>{information.title}</strong>
							</p>
							<p className="section-body">{information.details}</p>
						</section>
						))
					: !infoLoading && <>お知らせはありません</>}
				</div>
				</div>
			</div>
		</div>
	</div>
  );
}
